import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
// models
import { EventSubscriptionType, EventType, EventModel } from '../../../../shared/interfaces/event.model';
import { DynamicHostModel } from '../../../../shared/modal/models/dynamic-host.model';
// Services
import { NRModalService } from '../../../../shared/modal/services/nrmodal.service';
import { BroadcastService } from '../../../../shared/services/broadcast.service';
import { SwalService } from '../../../../shared/services/swal.service';
import { AdsService } from '../../../../services/ads.service';
// Components
import { AdsEditCreateComponent } from './modal/edit-create/edit-create.component';

@Component({
    templateUrl: './ads.component.html',
    styleUrls: ['./ads.component.scss']
})
export class AdsComponent implements OnInit, OnDestroy {

    dtConfig = {
        config: {
            base: this.adsService,
            api: 'datatable',
            rowsPerPage: 15,
            order: [[2, 'desc']]
        },
        columns: [
            {
                title: 'ID',
                field: 'id'
            },
            {
                title: 'Nombre',
                field: 'name'
            },
            {
                title: 'Ruta',
                field: 'route.name',
                default: 'No asignada'
            },
            {
                title: 'Activo',
                field: 'active',
                type: 'boolean'
            }
        ],
        actions: [
            {
                display: 'Editar',
                icon: 'fa-pencil',
                event: 'ads.edit',
                conditionality: 'true'
            },
            {
                display: 'Eliminar',
                icon: 'fa-trash',
                event: 'ads.delete',
                conditionality: 'true'
            }
        ]
    };

    bc$: any;

    constructor(
        public modalRef: BsModalService,
        private componentFactoryResolver: ComponentFactoryResolver,
        private broadcast: BroadcastService,
        private nrModal: NRModalService,
        private swal: SwalService,
        private adsService: AdsService
    ) { }

    ngOnDestroy(): void {
        if (this.bc$) {
            this.bc$();
        }
    }

    ngOnInit(): void {
        this.bc$ = this.broadcast.on(EventSubscriptionType.TYPE, EventType.MODAL, (event: EventModel) => {
            const props = this.prepareProps(event);
            if (props) {
                this.nrModal.open(props);
            }
        });
    }

    prepareProps(event: EventModel): any {
        const props: DynamicHostModel = new DynamicHostModel;
        props.instantiated = false;
        props.modalModel = {
            component: null,
            componentFactoryResolver: this.componentFactoryResolver,
            data: event.data.item || {}
        };

        switch (event.name) {
            case 'ads.add':
                props.modalModel.component = AdsEditCreateComponent;
                props.modalModel.modalConfiguration = {
                    title: 'Agregar Publicidad'
                };
                break;

            case 'ads.edit':
                props.modalModel.component = AdsEditCreateComponent;
                props.modalModel.modalConfiguration = {
                    title: 'Editar Publicidad'
                };
                break;

            case 'ads.delete':
                this.delete(event.data);
                return false;
                break;
        }

        return props;
    }

    /**
   * 
   */
    add(): void {
        this.broadcast.fire({
            name: 'ads.add',
            type: EventType.MODAL,
            data: {}
        });
    }

    /**
     * 
     * @param data 
     */
    delete(data): void {
        const swalParams = {
            title: `¿Estás seguro de querer eliminar la publicidad ${data.item.name}?`
        };

        this.swal.warning(swalParams).then(result => {
            if (result.value) {
                this.adsService.delete(data.item.id).subscribe((resp: any) => {
                    if (resp.success) {
                        this.swal.success({ title: 'Publicidad eliminado exitosamente' }).then(() => {
                            this.modalRef.hide(0);
                            this.broadcast.reloadDataTable();
                        });
                    } else {
                        this.swal.error('Ocurrio un error al intentar borrar la publicidad');
                    }
                });
            }
        });
    }

}
